export default __webpack_public_path__ + "static/media/foto7.2970b07d.jpg";